import React from 'react';
import './style/App.css';
import Login from "./Login"
import Dashboard from "./dashboard"
import EmailList from "./emailList"
import Profile from "./profile"
import NewUserSetup from "./newUserSetup"
import Events from "./events"
import SecurityEvent from "./securityEvents"
import Policy from "./policy"
import Logout from "./logout"
import { BrowserRouter as Router} from "react-router-dom"
import { AuthProvider } from "./Auth"
import PrivateRoute from './PrivateRoute'
import RedirectRoute from './RedirectRoute'
import firebaseP from './firebasePersistance'

function App(){

        return (
                <AuthProvider>
                <Router>

                <div className="App">
                    <RedirectRoute exact path ="/" component={Login}/>
                    <PrivateRoute exact path ="/dashboard" component={Dashboard}/>
                    <PrivateRoute exact path ="/emailList" component={EmailList}/>
                    <PrivateRoute exact path ="/profile" component={Profile}/>
                    <PrivateRoute exact path ="/newUserSetup" component={NewUserSetup}/>
                    <PrivateRoute exact path ="/events" component={Events}/>
                    <PrivateRoute exact path ="/securityEvents" component={SecurityEvent}/>
                    <PrivateRoute exact path ="/policy" component={Policy}/>
                    <PrivateRoute exact path ="/logout" component={Logout}/>
                </div>
                </Router>
                </AuthProvider>
        );
}
export default App;